import React from 'react'
import type { RefereeMinuteBand } from '../../../types'

interface MinuteBandChartProps {
  bands: RefereeMinuteBand[]
  height?: number
}

export function MinuteBandChart({ bands, height = 80 }: MinuteBandChartProps) {
  if (!bands || bands.length === 0) return null

  // Find max percentage for scaling
  const maxPct = Math.max(...bands.map((b) => b.percentage), 20) // Min 20% for scale

  return (
    <div className="minute-band-chart" style={{ height }}>
      <div className="minute-band-bars">
        {bands.map((band, i) => {
          const barHeight = (band.percentage / maxPct) * 100

          // Color based on percentage (higher = more intense)
          const getBarColor = () => {
            if (band.percentage >= 20) return 'var(--color-danger)'
            if (band.percentage >= 15) return 'var(--color-warning)'
            return 'var(--color-primary)'
          }

          return (
            <div key={i} className="minute-band-bar-container">
              <div
                className="minute-band-bar"
                style={{
                  height: `${barHeight}%`,
                  backgroundColor: getBarColor(),
                }}
                title={`${band.band}: ${band.percentage.toFixed(1)}%${band.count ? ` (${band.count} cards)` : ''}`}
              />
              <span className="minute-band-label">{band.band}</span>
            </div>
          )
        })}
      </div>
      <div className="minute-band-axis">
        <span>{maxPct.toFixed(0)}%</span>
        <span>{(maxPct / 2).toFixed(0)}%</span>
        <span>0%</span>
      </div>
    </div>
  )
}
